import { useState } from "react";
import { faqs } from "@/mocks/animeData";

function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <span className="text-xs font-semibold tracking-widest text-primary-600 uppercase">
            FAQ
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">
            关于小狗看番的常见问题
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm md:text-base text-foreground-700">
            第一次来？这些问题的答案能帮你更快上手。
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open
                    ? "border-primary-200 bg-background-100"
                    : "border-background-200/70 bg-background-100/50"
                }`}
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="font-medium text-foreground-950 text-sm md:text-base">
                    {f.q}
                  </span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-transform duration-300 ${
                      open
                        ? "rotate-180 bg-primary-500 text-background-50"
                        : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-700">
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Faq;